import View from '../src/lowcode/prototypeView';
export default View;
